export const ORGANIZATIONS_API_URL = 'ui/organization/organizations';
